import type { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Eyebrow } from '@/components/ui/eyebrow';
import { Pill } from '@/components/ui/pill';

interface Props {
  eyebrow: string;
  title: string;
  description: string;
  icon: LucideIcon;
  bullets?: string[];
  etaLabel?: string;
}

export function ComingSoon({ eyebrow, title, description, icon: Icon, bullets, etaLabel }: Props) {
  return (
    <div className="flex flex-col gap-5">
      <header>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="font-display text-[34px] md:text-[42px] font-bold tracking-[-0.03em] text-fg leading-[1.0] mt-1">
          {title}
        </h1>
        <p className="text-sm text-fg-muted mt-2 max-w-2xl">{description}</p>
      </header>

      <Card variant="default" className="p-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-md mx-auto">
          <div className="grid h-16 w-16 place-items-center rounded-full bg-mint-soft text-mint-deep shadow-[inset_0_2px_4px_rgba(40,90,70,0.10)]">
            <Icon className="h-7 w-7" strokeWidth={1.6} />
          </div>
          <div>
            <h3 className="font-display text-[20px] font-semibold tracking-[-0.015em] text-fg">
              Esta tela está em construção
            </h3>
            <p className="text-sm text-fg-muted mt-1.5">
              Estamos finalizando a estrutura técnica antes de habilitar entradas aqui. Você verá os
              cadastros assim que liberarmos.
            </p>
          </div>
          {bullets && bullets.length > 0 && (
            <ul className="flex flex-col gap-1.5 text-left text-sm text-fg-muted bg-card-soft rounded-2 p-4 w-full">
              {bullets.map((b) => (
                <li key={b} className="flex gap-2 items-start">
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-mint-deep shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}
          {etaLabel && (
            <Pill tone="lilac" dot>
              {etaLabel}
            </Pill>
          )}
        </div>
      </Card>
    </div>
  );
}
